<template>
  <dt :class="['text-sm font-semibold text-gray-900', className] | twMerge">
    <slot />
  </dt>
</template>

<script>
export default {
  name: 'DescriptionTerm',
  props: {
    className: [String, Array]
  }
}
</script>
